<div class="main-ho-tree">
    <div class="visibility" *ngIf="displayComponentsVisbilityToggler">
        <mat-slide-toggle [checked]="componentsVisbility" [(ngModel)]="componentsVisbility"
            [disabled]="readOnlyContent || isUserFromeEngineering" (change)="saveWellTreeComponentsVisibility()">
            Datos Generales y Componentes visibles
        </mat-slide-toggle>
    </div>
    <div class="tree-general-data" *ngIf="componentsVisbility">
        <div>
            <p class="title-section">Datos Generales</p>
        </div>
        <div class="general-data">
            <form class="form-data">
                <table class="table-data">
                    <tr class="row-label">
                        <td>
                            <mat-label>Presión de Diseño [psi]</mat-label>
                        </td>
                        <td>
                            <mat-label>Diámetro Interior [pulg]</mat-label>
                        </td>
                        <td>
                            <mat-label>Cabezal</mat-label>
                        </td>
                        <td></td>
                    </tr>
                    <tr *ngIf="hasDataDesignPressure || hasDataWellheadSize || hasDataSupplier">
                        <td class="td-data">
                            <mat-label [ngClass]="{'label-visible': hasDataDesignPressure, 'label-no-visible': !hasDataDesignPressure}">
                                {{designPressure | number: '1.2-2'}}</mat-label>
                        </td>
                        <td class="td-data">
                            <mat-label [ngClass]="{'label-visible': hasDataWellheadSize, 'label-no-visible': !hasDataWellheadSize}">
                                {{wellheadSize}}</mat-label>
                        </td>
                        <td class="td-data">
                            <mat-label [ngClass]="{'label-visible': hasDataSupplier, 'label-no-visible': !hasDataSupplier}">
                                {{supplierName}}</mat-label>
                        </td>
                        <td class="col-actions">
                            <button mat-mini-fab (click)="saveTree(wellTree);" class="save-ho-icon save-tree" [disabled]="isDisabledSave || readOnlyContent" name="save">
                                <mat-icon class="material-icons-outlined">save</mat-icon>
                            </button>
                        </td>
                    </tr>
                    <tr *ngIf="!hasDataDesignPressure && !hasDataWellheadSize && !hasDataSupplier">
                        <td class="td-empty-state" colspan="4">
                            <div class="footer">
                                <div class="footer-no-data">No se encontraron datos.</div>
                                <div *ngIf="showFooterNoDataOrign" class="footer-no-data-origin">De existir datos en el sistema de origen, podrás visualizarlos acá.</div>
                            </div>
                        </td>
                    </tr>
                </table>

            </form>
        </div>
    </div>

    <div *ngIf="componentsVisbility">
        <p class="title-section">Componentes</p>
    </div>
    <div class="loading-shade" *ngIf="isLoading || isLoadingImages">
        <mat-spinner *ngIf="isLoading"></mat-spinner>
    </div>
    <table mat-table [dataSource]="treeComponents" id="tblTreeComponents" *ngIf="componentsVisbility" class="treeComponentsTable">
        <ng-container matColumnDef="compDescription">
            <mat-header-cell *matHeaderCellDef [ngClass]="'mat-table-header'"> Descripción del Componente </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.compDescription}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="diamIntComp">
            <mat-header-cell *matHeaderCellDef [ngClass]="'mat-table-header'"> Diámetro Interior [pulg] </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.diamIntComp}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="workingPressure">
            <mat-header-cell *matHeaderCellDef [ngClass]="'mat-table-header'"> Presión de Trabajo [psi] </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.workingPressure | number: '1.2-2'}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="manufacturer">
            <mat-header-cell *matHeaderCellDef [ngClass]="'mat-table-header'"> Fabricante </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.manufacturer}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="valveState">
            <mat-header-cell *matHeaderCellDef [ngClass]="'mat-table-header'"> Estado </mat-header-cell>
            <mat-cell *matCellDef="let element, let i = index">
                    <mat-button-toggle-group  aria-label="Font Style" [value]="element.valveState"  [(ngModel)]="element.valveState" (click)="uncheckToggle(i)" (ngModelChange)="enableByValveSaveButton(i, element.valveState)" [disabled]="readOnlyContent || riskAlertDisabled()" >
                        <mat-button-toggle  value="Cerrada"  [ngClass]="element.valveState == 'Cerrada' ? 'red-button-toggle' : ''">Cerrada</mat-button-toggle>
                        <mat-button-toggle  value="N/A">N/A</mat-button-toggle>
                        <mat-button-toggle  value="Abierta" [ngClass]="element.valveState == 'Abierta' ? 'green-button-toggle' : ''" >Abierta</mat-button-toggle>
                    </mat-button-toggle-group>  
            </mat-cell> 
        </ng-container>
        <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let wellhead; let i = index" [ngClass]="'mat-column-save'">
                <button mat-mini-fab (click)="openComments(treeComponents[i], i, $event, readOnlyContent || isUserFromeEngineering);" class="comment-ho-icon" name="openComments">
                <mat-icon class="material-icons-outlined">chat_bubble_outline</mat-icon>
                <div class="circle-comments" *ngIf="treeComponents[i].comments"></div>
                <span class = "comment">Comentar</span>
              </button>
                <button mat-mini-fab (click)="saveComponent(treeComponents[i], i);" class="save-ho-icon save-component" [disabled]="isDisabled[i] || isUserFromeEngineering" name="save-component">
                <mat-icon class="material-icons-outlined">save</mat-icon>
              </button>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="noData">
            <mat-footer-cell *matFooterCellDef colspan="5">
                <div class="footer">
                    <div class="footer-no-data">No se encontraron datos.</div>
                    <div *ngIf="showFooterNoDataOrign" class="footer-no-data-origin">De existir datos en el sistema de origen, podrás visualizarlos acá.</div>
                </div>
            </mat-footer-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        <mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide-footer':hideFooter}"></mat-footer-row>

    </table>
    <div class="multiple-save" *ngIf="componentsVisbility && !readOnlyContent && !isUserFromeEngineering && treeComponents.length > 0">
        <button mat-button class="save" title="Guardar" (click)="saveMultipleComponents()" [disabled]="readOnlyContent || isUserFromeEngineering">
            <mat-icon class="material-icons-outlined">save</mat-icon>Guardar
        </button>
    </div>

    <!-- File Attachment -->
    <div class="handover-files">
        <div class="top">
            <h2>Planilla de Prueba de Árbol y Cabezal</h2>
            <div>
                <div *ngIf="wellTreeAttachment == null">
                    0{{ "/" + fileLimit + " Archivos" }}
                  </div>
                  <div *ngIf="wellTreeAttachment != null">
                    {{ wellTreeAttachment?.length + "/" + fileLimit + " Archivos" }}
                  </div>
            </div>
            <ng-container *ngIf="wellTreeAttachment?.length < fileLimit">
                <input
                  type="file"
                  class="file-input"
                  accept=".xls, .xlsx, .pdf, .jpg, .jpeg, .png, .gif"
                  (change)="onFileSelected($event)"
                  #fileUpload
                  style="display: none"
                />
                <div class="attach" title="Documento">
                    <button
                    mat-button
                    class = "upload-button"
                    (click)="fileUpload.click()"
                    [disabled]="readOnlyContent || isUserFromeEngineering">
                    <mat-icon class="material-icons-outlined">file_upload</mat-icon>Adjuntar archivo</button><br/>
                  <span>Archivos Excel, PDF e Imágenes</span>
                </div>
            </ng-container>
        </div>

        <div class="grid-attachment">
            <div class = "attachment" *ngFor="let f of wellTreeAttachment">
                <a
                    class="attachment-link"
                    href="{{dhoApiUrl}}/{{ f?.file_path }}"
                    download="{{ f?.file_original_name }}"
                    target="_blank"
                >
                    {{ f?.file_original_name }}
                </a>
                <!-- Boton borrar-->
                <button
                    *ngIf="!readOnlyContent && !isUserFromeEngineering"
                    mat-button
                    class="delete-button"
                    (click)="deleteWellTreeAttachment(f.file_id)"
                    [disabled]="readOnlyContent"
                >
                    <mat-icon class="material-icons-outlined">delete</mat-icon>
                </button>
            </div>
        </div>

    </div>

    <div class="handover-images">
        <div class="top">
            <h2>Imágenes de Instalación de Boca de Pozo</h2>

            <div clas="count">{{images.length + '/' + imageLimit + ' imágenes'}}</div>

            <div class="attach" *ngIf="images.length < imageLimit">
                <button mat-button [disabled]="readOnlyContent || isUserFromeEngineering" (click)="attachImage()">
          <mat-icon class="material-icons-outlined">file_upload</mat-icon>Adjuntar foto o diagrama
        </button><br>
                <span>Archivos PNG, JPG están permitidos</span>
            </div>
        </div>

        <div class="grid">
            <div class="image" *ngFor="let image of images; index as i; first as isFirst">
                <div class="actions">
                    <div class="button">
                        <button *ngIf="!readOnlyContent && !isUserFromeEngineering" mat-icon-button (click)="deleteImage(image, i)">
                            <mat-icon class="material-icons-outlined">delete</mat-icon>
                        </button> &nbsp;
                        <span class="legend" *ngIf="!readOnlyContent">Eliminar</span>
                    </div>
                    <div class="button">
                        <span class="legend">Ampliar</span>&nbsp;
                        <button mat-icon-button (click)="openImage(image)">
                            <mat-icon class="material-icons-outlined">open_in_full</mat-icon>
                        </button>
                    </div>
                </div>
                <img src="{{dhoApiUrl}}/{{image.imagePath}}" alt="{{image.imageDescription}}" />
                <div class="description" *ngIf="image.imageDescription">
                    {{image.imageDescription}}
                </div>
            </div>
        </div>
    </div>
</div>
